import { fontStyle, colors } from "Constants";

export const textAreaStyle = {
  border: "unset",
  paddingTop: 0,
  paddingLeft: 0,
  paddingRight: 0,
  fontSize: "1.6rem",
  lineHeight: "24px",
  ...fontStyle.medium,
  color: colors.textDefault,
  borderBottom: `1px solid ${colors.borderSubtle}`,
  borderRadius: "unset",
};

export const textAreaInputContainerStyle = {
  flexShrink: 1,
};
